export default "__VITE_ASSET__rCPcpgCr__"